/* eslint-disable max-len */
import { Selection } from '@leverege/ui-redux';
import { Attributes } from '@leverege/ui-attributes';
import { GeoshapeAdapter } from '@leverege/ui-mapbox-elements';
import Model from "./GeoShapeModel.js";
import Util from "./Util.js";
const {
  getFillColor,
  getFillOpacity,
  getFillPattern,
  getLineColor,
  getLineOpacity,
  getLineWidth,
  getLineCap,
  getLineJoin,
  getLinePattern,
  getLineStyle,
  getLabelVisible,
  getLabelColor,
  getLabelOpacity,
  getLabelSize,
  getLabelAttribute,
  getLabelAttribute2,
  getLabelAttribute2Scale,
  getAllowOverlap,
  getIgnorePlacement,
  getRolloverFillColor,
  getRolloverFillOpacity,
  getRolloverFillPattern,
  getRolloverLineColor,
  getRolloverLineOpacity,
  getRolloverLineWidth,
  getRolloverLineCap,
  getRolloverLineJoin,
  getRolloverLineStyle,
  getRolloverLinePattern,
  getRolloverLabelVisible,
  getRolloverAllowOverlap,
  getRolloverIgnorePlacement,
  getRolloverLabelColor,
  getRolloverLabelOpacity,
  getRolloverLabelSize,
  getRolloverLabelAttribute,
  getRolloverLabelAttribute2,
  getRolloverLabelAttribute2Scale,
  getHasRolloverFillColor,
  getHasRolloverFillOpacity,
  getHasRolloverFillPattern,
  getHasRolloverLineColor,
  getHasRolloverLineOpacity,
  getHasRolloverLineWidth,
  getHasRolloverLineCap,
  getHasRolloverLineJoin,
  getHasRolloverLineStyle,
  getHasRolloverLabelVisible,
  getHasRolloverLabelColor,
  getHasRolloverLabelOpacity,
  getHasRolloverLabelSize,
  getHasRolloverLabelAttribute,
  getHasRolloverLabelAttribute2,
  getHasRolloverLabelAttribute2Scale,
  getSelectedFillColor,
  getSelectedFillOpacity,
  getSelectedFillPattern,
  getSelectedLineColor,
  getSelectedLineOpacity,
  getSelectedLineWidth,
  getSelectedLineCap,
  getSelectedLineJoin,
  getSelectedLinePattern,
  getSelectedLineStyle,
  getSelectedLabelVisible,
  getSelectedLabelColor,
  getSelectedLabelOpacity,
  getSelectedLabelSize,
  getSelectedLabelAttribute,
  getSelectedLabelAttribute2,
  getSelectedLabelAttribute2Scale,
  getSelectedAllowOverlap,
  getSelectedIgnorePlacement,
  getHasSelectedFillColor,
  getHasSelectedFillOpacity,
  getHasSelectedFillPattern,
  getHasSelectedLineColor,
  getHasSelectedLineOpacity,
  getHasSelectedLineWidth,
  getHasSelectedLineCap,
  getHasSelectedLineJoin,
  getHasSelectedLineStyle,
  getHasSelectedLabelVisible,
  getHasSelectedLabelColor,
  getHasSelectedLabelOpacity,
  getHasSelectedLabelSize,
  getHasSelectedLabelAttribute,
  getHasSelectedLabelAttribute2,
  getHasSelectedLabelAttribute2Scale
  // getHasSelectedSubLabelVisible, getHasSelectedSubLabelColor, getHasSelectedSubLabelOpacity, getHasSelectedSubLabelSize, getSelectedSubLabelAttribute, 
} = Model;
class GeoShapeAdapter extends GeoshapeAdapter {
  getShapeData(item, id, options) {
    const app = {
      visible: true
    };
    let {
      model
    } = options;
    model = model || {};
    let showLabel = null;
    let labelAttr = null;
    let labelAttr2 = null;
    const allowOverlap = false;
    const ignorePlacement = false;
    const {
      attributeName
    } = options;
    let geoJson = Attributes.get(attributeName, item.type, item.data);
    if (typeof geoJson === 'string') {
      try {
        geoJson = JSON.parse(geoJson);
      } catch (err) {
        geoJson = null;
      }
    }
    if (geoJson == null) {
      return null;
    }
    const {
      rollover,
      selected,
      mapEditing
    } = options;
    const isMapEditing = Selection.isSelected(mapEditing, id);
    if (isMapEditing) {
      return null;
    }
    app.isRollover = Selection.isSelected(rollover, id);
    app.isSelected = Selection.isSelected(selected, id);
    const isPoly = geoJson.geometry?.type === 'Polygon';
    if (app.isSelected) {
      app.fillColor = app.fillColor == null ? getHasSelectedFillColor(model) ? Util.getColor(getSelectedFillColor(model), item) : null : app.fillColor;
      app.fillPattern = app.fillPattern == null ? getHasSelectedFillPattern(model) ? Util.getPattern(getSelectedFillPattern(model), item) : null : app.fillPattern;
      app.fillOpacity = app.fillOpacity == null ? getHasSelectedFillOpacity(model) ? Util.getNumber(getSelectedFillOpacity(model), item) : null : app.fillOpacity;
      app.lineColor = app.lineColor == null ? getHasSelectedLineColor(model) ? Util.getColor(getSelectedLineColor(model), item) : null : app.lineColor;
      app.lineWidth = app.lineWidth == null ? getHasSelectedLineWidth(model) ? Util.getNumber(getSelectedLineWidth(model), item) : null : app.lineWidth;
      app.lineOpacity = app.lineOpacity == null ? getHasSelectedLineOpacity(model) ? Util.getNumber(getSelectedLineOpacity(model), item) : null : app.lineOpacity;
      app.lineCap = app.lineCap == null ? getHasSelectedLineCap(model) ? getSelectedLineCap(model) : null : app.lineCap;
      app.lineJoin = app.lineJoin == null ? getHasSelectedLineJoin(model) ? getSelectedLineJoin(model) : null : app.lineJoin;
      showLabel = rvalue(model, item, getHasSelectedLabelVisible, getSelectedLabelVisible, showLabel);
      app.labelColor = rcolor(model, item, getHasSelectedLabelColor, getSelectedLabelColor, app.labelColor);
      app.labelSize = rnumber(model, item, getHasSelectedLabelSize, getSelectedLabelSize, app.labelSize);
      app.labelOpacity = rnumber(model, item, getHasSelectedLabelOpacity, getSelectedLabelOpacity, app.labelOpacity);
      labelAttr = rvalue(model, item, getHasSelectedLabelAttribute, getSelectedLabelAttribute, labelAttr);
      labelAttr2 = rvalue(model, item, getHasSelectedLabelAttribute2, getSelectedLabelAttribute2, labelAttr2);
      app.labelAttribute2Scale = rnumber(model, item, getHasSelectedLabelAttribute2Scale, getSelectedLabelAttribute2Scale, app.labelAttribute2Scale);
      app.allowOverlap = fvalue(model, item, allowOverlap, getSelectedAllowOverlap);
      app.ignorePlacement = fvalue(model, item, ignorePlacement, getSelectedIgnorePlacement);
      if (getHasSelectedLineStyle(model)) {
        const style = getSelectedLineStyle(model);
        app.outlineStyle = style || 'default';
        if (style === 'pattern') {
          app.linePattern = Util.getPattern(getSelectedLinePattern(model), item);
        }
      }
    }
    if (app.isRollover) {
      app.fillColor = app.fillColor == null ? getHasRolloverFillColor(model) ? Util.getColor(getRolloverFillColor(model), item) : null : app.fillColor;
      app.fillPattern = app.fillPattern == null ? getHasRolloverFillPattern(model) ? Util.getPattern(getRolloverFillPattern(model), item) : null : app.fillPattern;
      app.fillOpacity = app.fillOpacity == null ? getHasRolloverFillOpacity(model) ? Util.getNumber(getRolloverFillOpacity(model), item) : null : app.fillOpacity;
      app.lineColor = app.lineColor == null ? getHasRolloverLineColor(model) ? Util.getColor(getRolloverLineColor(model), item) : null : app.lineColor;
      app.lineWidth = app.lineWidth == null ? getHasRolloverLineWidth(model) ? Util.getNumber(getRolloverLineWidth(model), item) : null : app.lineWidth;
      app.lineOpacity = app.lineOpacity == null ? getHasRolloverLineOpacity(model) ? Util.getNumber(getRolloverLineOpacity(model), item) : null : app.lineOpacity;
      app.lineCap = app.lineCap == null ? getHasRolloverLineCap(model) ? getRolloverLineCap(model) : null : app.lineCap;
      app.lineJoin = app.lineJoin == null ? getHasRolloverLineJoin(model) ? getRolloverLineJoin(model) : null : app.lineJoin;
      showLabel = rvalue(model, item, getHasRolloverLabelVisible, getRolloverLabelVisible, null);
      app.labelColor = rcolor(model, item, getHasRolloverLabelColor, getRolloverLabelColor, null);
      app.labelSize = rnumber(model, item, getHasRolloverLabelSize, getRolloverLabelSize, null);
      app.labelOpacity = rnumber(model, item, getHasRolloverLabelOpacity, getRolloverLabelOpacity, null);
      app.labelAttribute2Scale = rnumber(model, item, getHasRolloverLabelAttribute2Scale, getRolloverLabelAttribute2Scale, null);
      labelAttr = rvalue(model, item, getHasRolloverLabelAttribute, getRolloverLabelAttribute, null);
      labelAttr2 = rvalue(model, item, getHasRolloverLabelAttribute2, getRolloverLabelAttribute2, null);
      app.allowOverlap = rvalue(model, item, getRolloverAllowOverlap);
      app.ignorePlacement = rvalue(model, item, getRolloverIgnorePlacement);
      if (getHasRolloverLineStyle(model)) {
        const style = getRolloverLineStyle(model);
        app.outlineStyle = style || 'default';
        if (style === 'pattern') {
          app.linePattern = Util.getPattern(getRolloverLinePattern(model), item);
        }
      }
    }
    app.fillColor = app.fillColor == null ? Util.getColor(getFillColor(model), item) : app.fillColor;
    app.fillPattern = app.fillPattern == null ? Util.getPattern(getFillPattern(model), item) : app.fillPattern;
    app.fillOpacity = app.fillOpacity == null ? Util.getNumber(getFillOpacity(model), item) : app.fillOpacity;
    app.lineColor = app.lineColor == null ? Util.getColor(getLineColor(model), item) : app.lineColor;
    app.lineOpacity = app.lineOpacity == null ? Util.getNumber(getLineOpacity(model), item) : app.lineOpacity;
    app.linePattern = app.linePattern == null ? Util.getPattern(getLinePattern(model), item) : app.linePattern;
    app.lineWidth = app.lineWidth == null ? Util.getNumber(getLineWidth(model), item) : app.lineWidth;
    app.lineCap = app.lineCap == null ? getLineCap(model) || 'butt' : app.lineCap;
    app.lineJoin = app.lineJoin == null ? getLineJoin(model) || 'mitre' : app.lineJoin;
    app.lineOffset = isPoly ? app.lineWidth * -0.5 : 0; // move line to outside of polygon
    app.showFill = app.fillColor != null || app.fillPattern != null;
    app.showOutline = app.lineColor != null || app.linePattern != null;
    app.fillStyle = app.fillPattern == null ? 'default' : 'pattern';
    app.outlineStyle = app.outlineStyle == null ? getLineStyle(model) || 'default' : app.outlineStyle;
    showLabel = fvalue(model, item, showLabel, getLabelVisible);
    app.labelColor = fcolor(model, item, app.labelColor, getLabelColor);
    app.labelSize = fnumber(model, item, app.labelSize, getLabelSize);
    app.labelOpacity = fnumber(model, item, app.labelOpacity, getLabelOpacity);
    app.labelAttribute2Scale = fnumber(model, item, app.labelAttribute2Scale, getLabelAttribute2Scale);
    labelAttr = fvalue(model, item, labelAttr, getLabelAttribute);
    labelAttr2 = fvalue(model, item, labelAttr2, getLabelAttribute2);
    app.label = showLabel ? Attributes.get(labelAttr || 'name', item.type, item.data) : null;
    app.label2 = showLabel && labelAttr2 ? Attributes.get(labelAttr2, item.type, item.data) : null;
    app.allowOverlap = app.allowOverlap == null && fvalue(model, item, allowOverlap, getAllowOverlap);
    app.ignorePlacement = app.allowOverlap == null && fvalue(model, item, ignorePlacement, getIgnorePlacement);
    app.color = 'rgb( 200, 100, 0 )';

    //  console.log( 'geoJson=', geoJson, item.type, Attributes.getAttribute( attributeName, item.type ) )

    // const geoJson2 = {
    //   type : 'Feature',
    //   properties : {},
    //   geometry : {
    //     type : 'Polygon',
    //     coordinates : [
    //       [
    //         [ -77.251, 39.182 ],
    //         [ -77.2509, 39.1824 ],
    //         [ -77.2508381, 39.180753 ],
    //         [ -77.2548381, 39.181753 ],
    //         [ -77.251, 39.182 ],
    //       ]
    //     ]
    //   }
    // }
    // const geoJson = { type : 'Feature', properties : {}, geometry : { type : 'Point', coordinates : [ ll.lon, ll.lat ] } }

    app.layerGroup = app.isRollover ? 'rollover' : app.isSelected ? 'selected' : null;
    app.showSymbol = true;
    app.showLabel = showLabel;
    return {
      dataType: item.type,
      dataRef: item.ref,
      geoJson,
      appearance: app
    };
  }
  getFillPaint(style, layerGroup, options) {
    const p = {
      'fill-color': ['case', ['has', 'fillColor'], ['get', 'fillColor'], 'rgba(0,0,0,0)'],
      'fill-opacity': ['case', ['has', 'fillOpacity'], ['get', 'fillOpacity'], 0.1]
    };
    // console.log( 'fill paint', style, layerGroup, options )
    if (style === 'pattern') {
      p['fill-pattern'] = ['get', 'fillPattern'];
    }
    return p;
  }
  getLinePaint(style, layerGroup, options) {
    const p = {
      'line-color': ['case', ['has', 'lineColor'], ['get', 'lineColor'], 'rgb( 0,0,0 )'],
      'line-width': ['case', ['has', 'lineWidth'], ['get', 'lineWidth'], 1],
      'line-offset': ['case', ['has', 'lineOffset'], ['get', 'lineOffset'], 0],
      'line-opacity': ['case', ['has', 'lineOpacity'], ['get', 'lineOpacity'], 1]
      // 'line-blur' : 10
    };
    switch (style) {
      case 'pattern':
        p['line-pattern'] = ['get', 'linePattern'];
        break;
      case 'long-dash':
        p['line-dasharray'] = [8, 3];
        break;
      case 'short-dash':
        p['line-dasharray'] = [3, 3];
        break;
      case 'dot':
        p['line-dasharray'] = [1, 1];
        break;
      case 'default':
      case 'custom':
        break;
      default:
        {
          const dashString = style.substring(5);
          const dashArray = dashString.split('-').reduce((prev, curr) => {
            prev.push(parseInt(curr));
            return prev;
          }, []);
          p['line-dasharray'] = dashArray;
        }
    }
    return p;
  }
  getLineLayout(style, layerGroup, options) {
    const {
      model
    } = options;
    const lineCap = Model.getLineCap(model) || 'butt';
    const lineJoin = Model.getLineJoin(model) || 'miter';
    return {
      'line-cap': lineCap,
      'line-join': lineJoin
    };
  }
  getLabelLayout(style, layerGroup, options) {
    const {
      model
    } = options;
    const {
      rollover,
      selected
    } = model;
    const prefix = rollover ? 'Rollover' : selected ? 'Selected' : '';
    return {
      'symbol-placement': 'point',
      'text-max-width': 10,
      'text-size': ['case', ['has', 'labelSize'], ['get', 'labelSize'], 12.0],
      'text-field': ['case', ['has', 'label2'], ['format', ['get', 'label'], {
        'font-scale': 1.0
      }, '\n', {}, ['get', 'label2'], {
        'font-scale': ['case', ['has', 'labelAttribute2Scale'], ['get', 'labelAttribute2Scale'], 0.8]
      }], ['get', 'label']],
      'text-font': ['Roboto Regular'],
      'text-anchor': 'center',
      'text-justify': 'center',
      'text-allow-overlap': model && Model[`get${prefix}AllowOverlap`](model) || false,
      // mapbox does not allow data expressions for this attribute
      'text-ignore-placement': model && Model[`get${prefix}IgnorePlacement`](model) || false // mapbox does not allow data expressions for this attribute
    };
  }
  getLabelPaint(style, layerGroup, options) {
    const {
      model
    } = options;
    const show = model && Model.getShowAtZoom(model);
    const hide = model && Model.getHideAtZoom(model);
    const fade = model && Model.getFadeZoom(model) || 0;
    let opacity = '{labelOpacity}';
    if (fade > 0.001) {
      if (typeof show === 'number') {
        if (typeof hide === 'number') {
          if (hide > show) {
            opacity = ['interpolate', ['exponential', 0.5], ['zoom'], show - fade, 0, show, 1, hide, 1, hide + fade, 0];
          }
        } else {
          opacity = ['interpolate', ['exponential', 0.5], ['zoom'], show - fade, 0, show, 1];
        }
      } else if (typeof hide === 'number') {
        opacity = ['interpolate', ['exponential', 0.5], ['zoom'], 1, hide, 1, hide + fade, 0];
      }
    } else if (typeof show === 'number') {
      if (typeof hide === 'number') {
        opacity = ['step', ['zoom'], 0, show, 1, hide, 0];
      } else {
        opacity = ['step', ['zoom'], 0, show, 1];
      }
    } else if (typeof hide === 'number') {
      opacity = ['step', ['zoom'], 1, hide, 0];
    }
    return {
      'text-color': ['case', ['has', 'labelColor'], ['get', 'labelColor'], 'rgb( 0,0,0 )'],
      'text-opacity': ['case', ['has', 'labelOpacity'], ['get', 'labelOpacity'], 1.0],
      'icon-opacity': opacity
      // Abrupt show/hide
      // "icon-opacity": [ 'step', ['zoom'], 0, 6, 1, 8, 0 ] 
      // smoother show/hide
      // "icon-opacity": [ 'interpolate', ['exponential', 0.5 ], ['zoom'], 5.5, 0, 6, 1, 10, 1, 10.5, 0 ]
      // {

      //   stops: [ [6, 1], [8, 1] ],
      //   default : 0
      // }
    };
  }

  // getSymbolLayout( style, layerGroup, options ) {
  //   const { model } = options
  //   const rScale = ( model && Model.getRolloverScale( model ) ) || 1
  //   const sScale = ( model && Model.getSelectedScale( model ) ) || 1
  //   const nScale = ( model && Model.getNormalScale( model ) ) || 1
  //   const scalesWithZoom = ( model && Model.getScalesWithZoom( model ) ) || false
  //   const scaleTo = ( model && Model.getScaleToZoom( model ) ) || 10
  //   const scaleFrom = ( model && Model.getScaleFromZoom( model ) ) || scaleTo - 4
  //   const toFac = ( model && Model.getScaleToFactor( model ) ) || 1
  //   const fromFac = ( model && Model.getScaleFromFactor( model ) ) || 0

  //   const flip = scaleTo < scaleFrom

  //   let size = 0.5 * nScale
  //   if ( layerGroup === 'rollover' ) { size = 0.5 * rScale }
  //   else if ( layerGroup === 'selected' ) { size = 0.5 * sScale }

  //   if ( scalesWithZoom ) { 
  //     size = {
  //       stops : flip ?
  //       [ [ scaleTo, size * toFac ], [ scaleFrom, size * fromFac ] ] :
  //       [ [ scaleFrom, size * fromFac ], [ scaleTo, size * toFac ] ],
  //       default : size 
  //     }
  //   }

  //   return { 
  //     ...SYMBOL_LAYOUT,
  //     'icon-size' : size
  //     // {
  //     //   // stops : [ [ 10, 0 ], [ 14, 0.25 ], [ 16, 0.75 ], [ 20, 0.5 ] ],
  //     //   stops : [ [ 7, 0 ], [ 12, 0.5 ] ],
  //     //   default : 1 
  //     // }

  //     // 'icon-size' : {
  //     //   stops : [ [ -1, 0 ], [ 6, 0 ], [ 8, 1 ], [ 9, 0 ] ],
  //     //   default : 0
  //     // }
  //     // 'icon-opacity' :  {
  //     //   stops: [[6, 1.0], [8, 0], [16, 0.3]]
  //     // },
  //     // 'icon-opacity222': [
  //     //   'step',
  //     //   ['zoom'],
  //     //   0.5, -1, 
  //     //   1, 6,
  //     //   1, 8,
  //     //   0.5
  //     //   ]
  //   }
  //   // return { 
  //   //   ...SYMBOL_LAYOUT,
  //   //   'icon-size' : layerGroup === 'rollover' ? 1.0 : layerGroup === 'selected' ? 0.75 : 0.5,
  //   // }
  // }

  /**
   * This returns the id of the layer which the style/layerGroup
   * layer should be placed before. The layer if must exist in the
   * map already: 'normal', 'selected', 'targeted', 'rollover' are
   * common examples
   * @param {string} style the style type of the layer group. This will be
   * the value returned in fillStyle, outlineStyle, labelStyle or 'default'.
   * @param {string} layerGroup the layerGroup type. 
   * @param {object} options the options object
   */
  getBefore(style, layerGroup, options) {
    const {
      order
    } = options;
    switch (layerGroup) {
      case 'selected':
        return 'selected';
      case 'targeted':
        return 'targeted';
      case 'rollover':
        return 'rollover';
      default:
        {
          if (order) {
            return `normal-${order}`;
          }
          return 'normal';
        }
    }
    // return 'normal'
  }
}

/**
 * Checks to see if object is rollovered, selected, and if those
 * have specific overrides.
 */
// function get( model, item, objectizer,
//   isRollover, rolloverActive, rolloverValue,
//   isSelected, selectedActive, selectedValue,
//   normalValue ) {

//   return ( isRollover && rolloverActive( model ) && objectizer( rolloverValue( model ), item ) ) ||
//       ( isSelected && selectedActive( model ) && objectizer( selectedValue( model ), item ) ) ||
//       objectizer( normalValue( model ), item )

// } 

function rcolor(model, item, has, get, dValue) {
  return has(model) ? Util.getColor(get(model), item) : dValue;
}
function rnumber(model, item, has, get, dValue) {
  return has(model) ? Util.getNumber(get(model), item) : dValue;
}
function rvalue(model, item, has, get, dValue) {
  return has(model) ? get(model) : dValue;
}
function fcolor(model, item, val, get) {
  return val == null ? Util.getColor(get(model), item) : val;
}
function fnumber(model, item, val, get, dValue) {
  return val == null ? Util.getNumber(get(model), item) : val;
}
function fvalue(model, item, val, get) {
  return val == null ? get(model) : val;
}
export default GeoShapeAdapter;